import { supabase } from '../lib/supabase/client';
import { Appointment } from '../types/models';
import { Database } from '../types/database.types';

type AppointmentRow = Database['public']['Tables']['appointments']['Row'];
type AppointmentInsert = Database['public']['Tables']['appointments']['Insert'];

export const appointmentService = {
  async getAll(): Promise<Appointment[]> {
    const { data, error } = await supabase
      .from('appointments')
      .select('*')
      .order('created_at', { ascending: false });
    
    if (error) throw error;
    
    return (data || []).map((row: AppointmentRow) => ({
      id: row.id,
      customerName: row.customer_name,
      customerEmail: row.customer_email,
      customerPhone: row.customer_phone,
      appointmentType: row.appointment_type,
      preferredDate: row.preferred_date,
      preferredTime: row.preferred_time,
      location: row.location,
      notes: row.notes,
      status: row.status,
      createdAt: row.created_at,
      updatedAt: row.updated_at,
    }));
  },

  async create(appointment: Omit<Appointment, 'id' | 'createdAt' | 'updatedAt' | 'status'>): Promise<Appointment> {
    const insertData: AppointmentInsert = {
      customer_name: appointment.customerName,
      customer_email: appointment.customerEmail,
      customer_phone: appointment.customerPhone,
      appointment_type: appointment.appointmentType,
      preferred_date: appointment.preferredDate,
      preferred_time: appointment.preferredTime,
      location: appointment.location,
      notes: appointment.notes,
    };

    const { data, error } = await supabase
      .from('appointments')
      .insert(insertData)
      .select()
      .single();
    
    if (error) throw error;
    
    return {
      id: data.id,
      customerName: data.customer_name,
      customerEmail: data.customer_email,
      customerPhone: data.customer_phone,
      appointmentType: data.appointment_type,
      preferredDate: data.preferred_date,
      preferredTime: data.preferred_time,
      location: data.location,
      notes: data.notes,
      status: data.status,
      createdAt: data.created_at,
      updatedAt: data.updated_at,
    };
  },
};